import { zodResolver } from '@hookform/resolvers/zod';
import { Input } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { useForm } from 'react-hook-form';
import { FormSheet } from '../FormSheet.tsx';
import {
  CONFIRMATION_WINDOW_HOURS,
  orderSettingsFormSchema,
  type OrderSettingsBody,
  type OrderSettingsFormValues,
} from './order-settings.ts';

export type OrderSettingsSheetProps = {
  hours: number;
  submitting: boolean;
  errorMessage: string | null;
  onClose: () => void;
  onSubmit: (body: OrderSettingsBody) => void;
};

export const OrderSettingsSheet = ({
  hours,
  submitting,
  errorMessage,
  onClose,
  onSubmit,
}: OrderSettingsSheetProps) => {
  const { t } = useTranslation();
  const form = useForm<OrderSettingsFormValues>({
    resolver: zodResolver(orderSettingsFormSchema),
    defaultValues: { orderConfirmationTtlHours: hours },
    mode: 'onBlur',
  });
  const invalid = form.formState.errors.orderConfirmationTtlHours;

  return (
    <FormSheet
      open
      formId="order-settings-form"
      title={t('orderSettings.title')}
      submitting={submitting}
      errorMessage={errorMessage}
      onClose={onClose}
      onSubmit={(event) => {
        void form.handleSubmit(onSubmit)(event);
      }}
    >
      <Input
        label={t('orderSettings.window')}
        type="number"
        inputMode="numeric"
        required
        min={CONFIRMATION_WINDOW_HOURS.min}
        max={CONFIRMATION_WINDOW_HOURS.max}
        helperText={t('orderSettings.windowHelp')}
        errorText={invalid ? t('orderSettings.windowInvalid', CONFIRMATION_WINDOW_HOURS) : undefined}
        {...form.register('orderConfirmationTtlHours', { valueAsNumber: true })}
      />
    </FormSheet>
  );
};
